module.exports = __webpack_public_path__ + "static/media/boondi-ke-ladoo.e99e7aad.jpg";